import React from "react";

export default function InfoIcon({
	color = "#A3A4A6",
	width = 14,
	height = 14,
}) {
	return (
		<svg
			width={width}
			height={height}
			viewBox="0 0 14 14"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M6.9987 0.333008C3.32259 0.333008 0.332031 3.32356 0.332031 6.99967C0.332031 10.6758 3.32259 13.6663 6.9987 13.6663C10.6748 13.6663 13.6654 10.6758 13.6654 6.99967C13.6654 3.32356 10.6748 0.333008 6.9987 0.333008ZM8.47536 10.4908C8.10814 10.6352 6.83536 11.243 6.10203 10.5969C5.88314 10.4047 5.77425 10.1608 5.77425 9.86467C5.77425 9.31023 5.95648 8.8269 6.28481 7.66634C6.34259 7.4469 6.41314 7.16245 6.41314 6.9369C6.41314 6.54745 6.26536 6.44412 5.86481 6.44412C5.66925 6.44412 5.45259 6.51356 5.25648 6.5869L5.36481 6.14301C5.80203 5.96523 6.35092 5.74856 6.82092 5.74856C7.52592 5.74856 8.04481 6.10023 8.04481 6.76912C8.04481 6.9619 8.01148 7.29967 7.94148 7.53301L7.53592 8.96745C7.45203 9.25745 7.30036 9.8969 7.53536 10.0863C7.76648 10.2736 8.3137 10.1741 8.5837 10.0469L8.47536 10.4908ZM7.80536 4.77745C7.34536 4.77745 6.97203 4.40412 6.97203 3.94412C6.97203 3.48412 7.34536 3.11079 7.80536 3.11079C8.26536 3.11079 8.6387 3.48412 8.6387 3.94412C8.6387 4.40412 8.26536 4.77745 7.80536 4.77745Z"
				fill={color}
			/>
		</svg>
	);
}
